module.exports = __webpack_public_path__ + "static/media/NativityPreparatorySchool.bd331016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/NativityPreparatorySchool.jpg
// module id = 746
// module chunks = 0